<template>
    <div>
        <div v-if="show">
            <div class="pay_suss">
                <p>支付成功</p>
                <div class="pay_suss_return">
                    <button @click="seeorderlist">查看订单</button>
                    <button style="background:#E1041B;color:white;border:none;" @click="Continue">继续逛逛</button>
                </div>
            </div>
            <div class="pay_img"><img src="@/assets/pay.png" alt=""></div>
            <div class="pay_suorder">
                <div class="pay_divOne">
                    <div class="pay_divOnedis">{{data.name}}</div>
                    <div>{{data.phone}}</div>
                </div>
                <div class="pay_divcenter">{{data.addrNameFull}}{{data.detailAddress}}</div>
                <div class="pay_menoy">
                    <div>实付:</div>
                    <div class="pay_Lastone">¥{{query.money}}</div>
                </div>
            </div>
            <!-- <div class="pay_coupon" v-if="show_coupon && query.money>=100">
                <div class="conpon_div"></div>
                <div class="pay_center">
                    <div>
                        <template  v-if="query.money>=100 && query.money<=200">
                            <img src="@/assets/10_coupon.png" alt="" @click="Toastcouponfasle(31)" v-if="couponfasle===false">
                            <img src="@/assets/10_couponfasle.png" alt="" v-if="couponfasle" @click="Tostre">
                        </template>
                        <template v-if="query.money>=200 && query.money<=300">
                            <img src="@/assets/25_coupon.png" alt="" @click="Toastcouponfasle(32)" v-if="couponfasle===false">
                            <img src="@/assets/25_couponfasle.png" alt="" v-if="couponfasle" @click="Tostre">
                        </template>
                        <template v-if="query.money>=300">
                            <img src="@/assets/40_coupon.png" alt="" @click="Toastcouponfasle(33)" v-if="couponfasle===false">
                            <img src="@/assets/40_couponfasle.png" alt="" v-if="couponfasle" @click="Tostre">
                        </template>
                    </div>
                </div>
            </div> -->
        </div>
        <div v-else>
            <div class="pay_suss">
                <p style="color:#A72240;">支付失败</p>
                <div class="pay_r">
                    <div style="display:flex;justify-content: center;">
                        请在<span style="color:#A72240;">{{query.time}}</span>内完成付款
                    </div>
                    <div style="display:flex;justify-content: center;margin-top:5px;">
                        否则订单会被系统取消
                    </div>
                </div>
                <div class="pay_suss_return">
                    <button @click="seeorderlist">查看订单</button>
                    <button @click="gopay">重新支付</button>
                    <!-- this.$router.push({ path: '/pay', query: { id: id, money: money, time: time } }) -->
                </div>
            </div>
            <div class="pay_img"><img src="@/assets/pay.png" alt=""></div>
            <div class="pay_suorder">
                <div class="pay_divOne">
                    <div class="pay_divOnedis">{{query.address.name}}</div>
                    <div>{{query.address.phone}}</div>
                </div>
                <div class="pay_divcenter">{{query.address.addrNameFull}}{{query.address.detailAddress}}</div>
                <div class="pay_menoy">
                    <div>实付:</div>
                    <div class="pay_Lastone">¥{{query.money}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { payOrderQuery, payOrderAlipayQuery } from '@/request/api'
import { Toast } from 'vant'
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      query: {},
      data: {},
      show: false,
      // show_coupon: false,
      couponfasle: false
    }
  },
  methods: {
    Continue() {
      this.$router.push('/index')
      sessionStorage.removeItem('pay')
    },
    seeorderlist() {
      this.$router.push('/orderList')
      // sessionStorage.removeItem('pay')
    },
    gopay() {
      this.$router.push({ path: '/pay', query: { id: sessionStorage.getItem('pay').id, money: sessionStorage.getItem('pay').money, time: sessionStorage.getItem('pay').time } })
    }
    // Toastcouponfasle(item) {
    //   const params = {
    //     couponId: item
    //   }
    //   couponAdd(item, params).then(res => {
    //     console.log(res)
    //     if (res.code === 200) {
    //       this.couponfasle = true
    //       Toast('领取成功')
    //     } else {
    //       Toast(res.message)
    //     }
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }
  },
  beforeDestroy() {
    //   sessionStorage.removeItem('pay')
  },
  created() {
    console.log(this.$route)
    console.log(JSON.parse(this.$route.query.query))
    this.query = JSON.parse(this.$route.query.query)
    console.log(this.query)
    // "订单id有误"
    // data.message"获取支付结果失败"
    console.log(typeof sessionStorage.getItem('payType'))
    if (sessionStorage.getItem('payType') === '0') {
      payOrderQuery({ orderId: this.query.id }).then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.trade_state === 'SUCCESS') {
            this.show = true
          } else {
            this.show = false
          }
        } else {
          this.show = false
        }
      })
    } else {
      payOrderAlipayQuery({ out_trade_no: this.query.id }).then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.trade_state === 'SUCCESS') {
            this.show = true
          } else {
            this.show = false
          }
        } else {
          this.show = false
        }
      })
    }
    this.data = this.query.address
    // memberAddress(this.query.addressId).then(res => {
    //   console.log(res)
    //   this.data = res.data
    // })
    // const params = {
    //   id: this.query.id
    // }
    // orderInfo(this.query.id, params).then(res => {
    //   console.log(res.data)
    //   if (res.data.supplierCode === 'ZY') {
    //     this.show_coupon = true
    //   }
    // })
    // 4553762257837752321
  }
}
</script>
<style lang="less" scoped>
.pay_suss{
    width:750px;
    height:341px;
    background:rgba(255,255,255,1);
    p{
        color: #32963A;
        font-size: 44px;
        display: flex;
        justify-content: center;
        margin-top: 80px;
    }
    .pay_r{
        margin-top: 31px;
    }
    .pay_suss_return{
        margin-top: 71px;
        margin-left: 175px;
        button{
            width:192px;
            height:69px;
            border:1px solid rgba(102,102,102,1);/*no*/
            border-radius:4px;
            font-size: 28px;
            background-color: #fff;
            margin-right: 52px;
        }
    }
}
.pay_img{
    width: 100%;
    height: 43px;
    img{
        width: 100%;
        height: 100%;
    }
}
.pay_suorder{
    background:rgba(255,255,255,1);
    font-size: 28px;
    padding-left: 31px;
    .pay_divOne{
        display: flex;
        justify-content: flex-start;
        margin-top: 15px;
        .pay_divOnedis{
            width: 102px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }
    }
    .pay_divcenter{
        margin-top: 15px;
    }
    .pay_menoy{
        display: flex;
        justify-content: flex-start;
        color: #B4272D;
        margin-top: 15px;
        .pay_Lastone{
            margin-left: 61px;
        }
    }
}
.pay_coupon{
    width: 100%;
    height: 598px;
    margin-top: 34px;
    .conpon_div{
        height: 16px;
        background-color: #F2F2F2;
    }
    .pay_center{
        height: 582px;
        width: 100%;
        background: url('../../assets/di_coupon.png') no-repeat;
        background-size: 100% 100%;
        background-color: #F2F2F2;
        div{
            width: 658px;
            height: 182px;
            margin: 0 auto;
            padding-top: 114px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
